import { Outlet, ScrollRestoration } from "react-router-dom";

export function RootLayout() {
    if (
        window.location.hostname === "welnido.com" ||
        window.location.hostname === "portal.welnido.com"
    ) {
        window.location.replace("https://www.welnido.com");
        return;
    }

    return (
        <>
            <Outlet />
            <ScrollRestoration />
        </>
    );
}
